export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/as-plus-2.095338ca.svg","height":14,"width":147,"blurWidth":0,"blurHeight":0};